// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  Input,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SubTableHeader } from '../interfaces/sp-subtable-headers';
import { CommonModule } from '@angular/common';
import { LocalizedDatePipe } from '../../shared/pipes/localizedDate.pipe';
import { ClipboardService } from '../../shared/services/clipboard.service';
import { CalcSubtableColumnWidthDirective } from './calc-subtable-column-width/calc-subtable-column-width.directive';

@Component({
  selector: 'app-subtable',
  templateUrl: './subtable.component.html',
  styleUrls: ['./subtable.component.scss'],
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    TranslateModule,
    CommonModule,
    LocalizedDatePipe,
    CalcSubtableColumnWidthDirective,
  ],
})
export class SubtableComponent {
  @Input() headers: SubTableHeader[] = [];
  @Input() rows: any[] = [];

  public clipboardService = inject(ClipboardService);
}
